import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

import { FaReact, FaNodeJs } from "react-icons/fa";
import {
    SiRedux,
  SiHtml5,
  SiMaterialdesign,
  SiExpress,
  SiRedis,
  SiTailwindcss,
  SiNetlify
} from "react-icons/si";
import { DiCss3, DiMongodb } from "react-icons/di";
import { SiJavascript } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap } from "react-icons/bs";
import mui from "../assets/img/mui.svg"



export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
        <div className="techsection">
          <div  class="skills-card">
            <SiJavascript class="skills-card-img" />
            <h5 class="skills-card-name">Javascript</h5>
          </div>
          <div class="skills-card">
            <SiHtml5 class="skills-card-img" />
            <h5 class="skills-card-name">HTML</h5>
          </div>
          <div class="skills-card">
            <DiCss3 class="skills-card-img"/>
            <h5 class="skills-card-name">CSS</h5>
          </div>
          <div class="skills-card">
            <FaReact class="skills-card-img"/>
            <h5 class="skills-card-name">React</h5>
          </div>
          <div class="skills-card">
            <FaNodeJs class="skills-card-img"/>
            <h5 class="skills-card-name">Nodejs</h5>
          </div>
          <div class="skills-card">
            <DiMongodb class="skills-card-img"/>
            <h5 class="skills-card-name">MongoDb</h5>
          </div>

          <div class="skills-card">
            <SiExpress class="skills-card-img"/>
            <h5 class="skills-card-name">Express</h5>
          </div>

          <div class="skills-card">
          <img src={mui} alt="logo" class="skills-card-img" />
            <h5 class="skills-card-name">Material Ui</h5>
          </div>
          <div class="skills-card">
            <BsBootstrap class="skills-card-img" />
            <h5 class="skills-card-name">Bootstrap</h5>
          </div>
          <div class="skills-card">
            <SiTailwindcss class="skills-card-img"/>
            <h5 class="skills-card-name">Tailwind CSS</h5>
          </div>
          <div class="skills-card">
            <SiNetlify class="skills-card-img"/>
            <h5 class="skills-card-name">Netlify</h5>
          </div>
          <div class="skills-card">
            <VscGithub class="skills-card-img"/>
            <h5 class="skills-card-name">Github</h5>
          </div>
          
        </div>
                   
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}